var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 42Q33.65 42 27.625 39Q21.6 36 16.8 31.2Q12 26.4 9 20.375Q6 14.35 6 8.25Q6 7.3 6.65 6.65Q7.3 6 8.25 6H15.25Q15.95 6 16.475 6.475Q17 6.95 17.15 7.75L18.5 14.05Q18.6 14.75 18.475 15.325Q18.35 15.9 17.95 16.3L12.95 21.35Q15.75 26 19.225 29.45Q22.7 32.9 27.1 35.3L31.85 30.4Q32.35 29.85 33 29.625Q33.65 29.4 34.3 29.55L40.25 30.85Q41 31 41.5 31.6Q42 32.2 42 33V39.75Q42 40.7 41.35 41.35Q40.7 42 39.75 42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7b752858a699a71a349c86095961c690.svg";
export { ForwardRef as ReactComponent };